export default {
  data: () => ({
    Kilogram: {
      key: 'KILOGRAM',
      value: 'kg'
    },
    Piece: {
      key: 'PIECE',
      value: 'szt.'
    },
    Liter: {
      key: 'LITER',
      value: 'l'
    },
    Ton: {
      key: 'TON',
      value: 't'
    },
  }),
  methods: {
    getUnits() {
      return [this.Kilogram, this.Piece, this.Liter, this.Ton]
    },
    getUnitLabel(value) {
      return this.getUnits().find((tc) => tc.key === value).value
    }
  }
}
